<div class="asset-header" [class.asset-header--tanuh]="variant === 'tanuh'">
  <div class="asset-header--container">
    <div class="asset-header--content">
      <div class="asset-header--text">
        <nav class="asset-header--breadcrumbs" *ngIf="config.breadcrumbs && config.breadcrumbs.length > 0">
          <ol class="breadcrumbs--list">
            <li
              class="breadcrumbs--item"
              *ngFor="let crumb of config.breadcrumbs; let first = first"
            >
              <svg
                *ngIf="variant === 'tanuh' && !first"
                class="breadcrumbs--chevron"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <a [routerLink]="crumb.route" *ngIf="crumb.route; else noLink" class="breadcrumbs--link">
                <svg
                  *ngIf="first && crumb.label === 'Home'"
                  class="breadcrumbs--home-icon"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
                </svg>
                <span class="breadcrumbs--label-truncate" [title]="crumb.label">{{ crumb.label }}</span>
              </a>
              <ng-template #noLink>
                <span class="breadcrumbs--current breadcrumbs--label-truncate" [title]="crumb.label">{{ crumb.label }}</span>
              </ng-template>
            </li>
          </ol>
        </nav>
        <div class="asset-header--title-wrapper">
          <div class="asset-header--title-group">
            <span class="asset-header--title-icon" *ngIf="variant === 'tanuh'" aria-hidden="true">
              <ng-container [ngTemplateOutlet]="pageGlyph"></ng-container>
            </span>
            <h3 class="asset-header--title" [title]="config.title">{{ config.title }}</h3>
          </div>
          
          <div class="asset-header--custom-actions">
            <ng-content select="[headerActions]"></ng-content>
          </div>

          <div class="asset-header--actions" *ngIf="showActions || config.assetId">
            <!-- Copy Button -->
            <button 
              *ngIf="config.assetId" 
              class="asset-header--action-btn"
              (click)="copyAssetId()"
              [attr.aria-label]="'Copy asset ID'"
              [title]="copySuccess ? 'Copied!' : 'Copy asset ID'"
            >
              <svg class="asset-header--action-icon asset-header--copy-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2" stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="asset-header--copy-success" *ngIf="copySuccess">Copied!</span>
            </button>
            <!-- Like Button (heart icon) -->
            <button 
              *ngIf="showActions && showLikeButton"
              class="asset-header--action-btn"
              [class.active]="isLiked"
              (click)="onLikeClick()"
              [attr.aria-label]="isLiked ? 'Unlike this asset' : 'Like this asset'"
              [title]="isLiked ? 'Unlike' : 'Like'"
            >
              <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="asset-header--action-icon asset-header--like-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" 
                  [attr.fill]="isLiked ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
              </svg>
            </button>
            <!-- Bookmark Button (ribbon bookmark icon) -->
            <button 
              *ngIf="showActions"
              class="asset-header--action-btn"
              [class.active]="isBookmarked"
              (click)="onBookmarkClick()"
              [attr.aria-label]="isBookmarked ? 'Remove bookmark' : 'Bookmark this asset'"
              [title]="isBookmarked ? 'Remove bookmark' : 'Bookmark this asset'"
            >
              <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="asset-header--action-icon asset-header--bookmark-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z" 
                  [attr.fill]="isBookmarked ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Pinned Button (discussions only) – pinned icon -->
            <button 
              *ngIf="showPinButton"
              class="asset-header--action-btn"
              [class.active]="isPinned"
              (click)="onPinClick()"
              [attr.aria-label]="isPinned ? 'Unpin this discussion' : 'Pin this discussion'"
              [title]="isPinned ? 'Unpin this discussion' : 'Pin this discussion'"
            >
              <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg class="asset-header--action-icon asset-header--pinned-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1.03 1 1.03-1v-7H19v-2c-1.66 0-3-1.34-3-3z" 
                  [attr.fill]="isPinned ? '#059669' : 'none'" 
                  stroke="#059669" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"/>
              </svg>
            </button>

            <!-- Thumbs up / Upvote (discussion detail only) -->
            <ng-container *ngIf="showVoteButtons">
              <button 
                class="asset-header--action-btn asset-header--vote-btn"
                [class.active]="userVote === 'up'"
                (click)="onUpvoteClick()"
                [attr.aria-label]="userVote === 'up' ? 'Remove upvote' : 'Upvote'"
                [title]="userVote === 'up' ? 'Remove upvote' : 'Upvote'"
              >
                <svg *ngIf="!isLoggedIn" class="asset-header--lock-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7 11V7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg class="asset-header--action-icon asset-header--vote-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22V11" stroke="#059669" [attr.fill]="userVote === 'up' ? '#059669' : 'none'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </ng-container>
          </div>
        </div>
        <p class="asset-header--created-at" *ngIf="config.createdAt">Created at {{ config.createdAt }}</p>
        <ng-container *ngIf="config.description">
          <p
            #descriptionEl
            id="asset-header-description"
            class="asset-header--description"
            [class.asset-header--description--expanded]="descriptionExpanded"
          >{{ config.description }}</p>
          <button
            *ngIf="descriptionOverflows"
            type="button"
            class="asset-header--description-toggle"
            (click)="toggleDescription()"
            [attr.aria-expanded]="descriptionExpanded"
            aria-controls="asset-header-description"
          >
            {{ descriptionExpanded ? 'Read less' : 'Read more' }}
          </button>
        </ng-container>
      </div>

      <div class="asset-header--figure" *ngIf="variant === 'tanuh'" aria-hidden="true">
        <span class="asset-header--figure-icon">
          <ng-container [ngTemplateOutlet]="pageGlyph"></ng-container>
        </span>
      </div>
      
      <div class="asset-header--icons" *ngIf="variant !== 'tanuh' && config.iconPath">
        <img [src]="config.iconPath" alt="" class="asset-header--icon-image" />
      </div>
    </div>
  </div>
</div>

<ng-template #pageGlyph>
  <svg *ngIf="pageIcon === 'dataset'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="6" rx="8" ry="3" stroke="currentColor" stroke-width="1.8"/>
    <path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6" stroke="currentColor" stroke-width="1.8"/>
    <path d="M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" stroke="currentColor" stroke-width="1.8"/>
  </svg>
  <svg *ngIf="pageIcon === 'model'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M12 3 20 7.5v9L12 21 4 16.5v-9L12 3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
    <path d="M12 12 20 7.5M12 12v9M12 12 4 7.5" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'discussion'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M5 16.5 4 21l4.5-1.5A8.5 8.5 0 1 0 5 16.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
    <path d="M8.5 10h7M8.5 13.5h4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'challenge'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M7 4h10v5a5 5 0 0 1-10 0V4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
    <path d="M7 6H4a3 3 0 0 0 3 3M17 6h3a3 3 0 0 1-3 3M12 14v3M9 20h6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'knowledge'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    <path d="M6.5 2H20v15H6.5A2.5 2.5 0 0 0 4 19.5V4.5A2.5 2.5 0 0 1 6.5 2Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'sandbox'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.8"/>
    <path d="M7 9h.01M7 12h.01M10 12h7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'leaderboard'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M4 19V11h4v8M10 19V5h4v14M16 19v-6h4v6" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'submit'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M12 16V4M7 9l5-5 5 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 20h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'library'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M4 19V5M8 19V8M12 19V5M16 19V8l4-3v14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'toolkit'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4L16 11l-3-3 1.7-1.7Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
  </svg>
  <svg *ngIf="pageIcon === 'usecase'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
    <rect x="13" y="4" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
    <rect x="4" y="13" width="16" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
  </svg>
  <svg *ngIf="pageIcon === 'default'" width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M6.2 6.2l2.1 2.1M15.7 15.7l2.1 2.1M17.8 6.2l-2.1 2.1M8.3 15.7l-2.1 2.1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.8"/>
  </svg>
</ng-template>

